import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssetsService, PanelItemAssetVM } from '../../infrastructure/services/assets.service';
import { AlertService, GrowlType } from '../../infrastructure/services/alert.service';

@Component({
  templateUrl: 'listado.assets.component.html'
})
export class ListadoAssetsComponent implements OnInit {
  public search: string;
  tipoEntidad: string;
  codSistema: string;
  codNegocio: string;
  codSponsor: string;
  codProducto: string;
  organizationCode: string;
  assets: PanelItemAssetVM[];
  preguntarSiDeseaBorrar = [];
  constructor(private aRoute: ActivatedRoute,
              private alertService: AlertService,
              private assetsService: AssetsService) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      const { title } = this.aRoute.snapshot.data;

      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codSponsor = null;
      this.codProducto = params['codproducto'];
      this.organizationCode = params['codorganizacion'];

      if (title) {
        this.tipoEntidad = title;
      } else {
        this.tipoEntidad = this.codProducto ? 'PRODUCTO' : 'NEGOCIO';
      }

      // Obtengo todos los assets asociados al producto
      this.obtenerAssets();
    });
  }

  eliminar(idAsset) {
    this.assetsService.eliminar(idAsset)
      .then(assetEliminado => {
          this.alertService.showGrowl({
            body: 'ASSET_REMOVED',
            type: GrowlType.SUCCESS
          }, { asset: assetEliminado.codAsset});

          // Busco el asset de la lista que corresponde con el asset borrado
          // y le reseteo el id, para que la tabla lo tome como no configurado
          // const index = this.assets.findIndex(asset => asset.idAsset === idAsset);
          // this.assets[index].idAsset = null;

          this.obtenerAssets();
      });
  }

  obtenerAssets() {
    if ( this.codProducto) {
      this.assetsService
        .getByProducto(this.organizationCode, this.codSistema, this.codNegocio, this.codSponsor, this.codProducto)
          .then(assets => this.assets = assets.filter(asset => !asset.esTipoFileManager));
    } else {
      this.assetsService
        .getBySponsor(this.organizationCode, this.codSistema, this.codNegocio, this.codSponsor)
          .then(assets => this.assets = assets.filter(asset => !asset.esTipoFileManager));
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/assets/listado.assets.component.ts